import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const PlusSquare = ({ color = colors.primary[600], ...props }: Props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0003 0.916039L9.83647 0.916027C7.82171 0.915807 6.62924 0.915677 5.63725 1.22845C3.53689 1.89069 1.89167 3.53592 1.22943 5.63628C0.916653 6.62826 0.916784 7.82073 0.917004 9.8355L0.917016 9.99937L0.917004 10.1633C0.916784 12.178 0.916653 13.3705 1.22943 14.3625C1.89167 16.4628 3.53689 18.1081 5.63725 18.7703C6.62924 19.0831 7.8217 19.0829 9.83646 19.0827L10.0003 19.0827L10.1642 19.0827C12.179 19.0829 13.3715 19.0831 14.3634 18.7703C16.4638 18.1081 18.109 16.4628 18.7713 14.3625C19.084 13.3705 19.0839 12.178 19.0837 10.1633L19.0837 9.99937L19.0837 9.83548C19.0839 7.82073 19.084 6.62826 18.7713 5.63628C18.109 3.53592 16.4638 1.89069 14.3634 1.22845C13.3715 0.915677 12.179 0.915807 10.1642 0.916027L10.0003 0.916039ZM6.08831 2.65902C6.83121 2.42479 7.77246 2.41604 10.0003 2.41604C12.2282 2.41604 13.1695 2.42479 13.9124 2.65902C15.546 3.1741 16.8256 4.45372 17.3407 6.08733C17.5749 6.83024 17.5837 7.77148 17.5837 9.99937C17.5837 12.2273 17.5749 13.1685 17.3407 13.9114C16.8256 15.545 15.546 16.8246 13.9124 17.3397C13.1695 17.574 12.2282 17.5827 10.0003 17.5827C7.77246 17.5827 6.83121 17.574 6.08831 17.3397C4.4547 16.8246 3.17508 15.545 2.66 13.9114C2.42577 13.1685 2.41702 12.2273 2.41702 9.99937C2.41702 7.77148 2.42577 6.83024 2.66 6.08733C3.17508 4.45372 4.4547 3.1741 6.08831 2.65902ZM10.7503 6.66604C10.7503 6.25183 10.4146 5.91604 10.0003 5.91604C9.58614 5.91604 9.25035 6.25183 9.25035 6.66604V9.24937H6.66702C6.2528 9.24937 5.91702 9.58516 5.91702 9.99937C5.91702 10.4136 6.2528 10.7494 6.66702 10.7494H9.25035V13.3327C9.25035 13.7469 9.58614 14.0827 10.0003 14.0827C10.4146 14.0827 10.7503 13.7469 10.7503 13.3327V10.7494H13.3337C13.7479 10.7494 14.0837 10.4136 14.0837 9.99937C14.0837 9.58516 13.7479 9.24937 13.3337 9.24937H10.7503V6.66604Z"
      fill={color}
    />
  </svg>
);

export default PlusSquare;
